export function extractVimeoId(urlOrId: string) {
    if (!urlOrId) return '';
    const match = urlOrId.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    return match ? match[1] : urlOrId; // if it’s already an ID, return as-is
}